import {
  Button,
  Dropdown,
  OverlayTrigger,
  Spinner,
  Tooltip,
} from "react-bootstrap";
import React, {useRef} from "react";
import AppTable from "../../includes/partials/tables/AppTable";
import { useSpeedPacks } from "../../context/SpeedPacksContext";
import { constructUrl, currencyFormat } from "../../utils";
import { AppContainer } from "../Layout/AppContainer";
import { useHistory, useRouteMatch } from "react-router-dom";
import Alert from "../../includes/Alert";
import Axios from "axios";
export const SpeedPacksList = (props) => {
  const [speedPacksState, setSpeedPacksState, getSpeedPacks] = useSpeedPacks();
  const history = useHistory();
  const match = useRouteMatch();

  const tablePdf = useRef(null);
  let speedPacks = speedPacksState.speedPacks;
  if (!speedPacksState.wasSpeedPacksLoaded) {
    return (
      <div className="d-flex justify-content-center h-100 align-items-center">
        <Spinner animation="grow" />
      </div>
    );
  }
  let headersAndSelectors = [
    {
      header: "Cantidad de Live Speed Dates",
      selector: "speed_dates_quantity",
    },
    { header: "Precio", selector: "price", skin: currencyFormat },
  ];

  const openEditForm = (id) => {
    setSpeedPacksState({ ...speedPacksState, selectedSpeedPackId: id });
    history.push(`${match.path}/editar`);
  };
  const deleteItem = async (id) => {
    try {
      let response = await Axios.get(
        constructUrl(`api/speed_packs/${id}/delete`)
      );
      if (!response.data.ok) throw new Error("Error al eliminar");
      Alert({ icon: "success", text: response.data.ok });
      getSpeedPacks();
    } catch (error) {
      Alert({ icon: "error", title: "Error", text: error });
    }
  };
  const buttonsOfOptions = (id) => {
    const buttons = [];
    buttons.push(
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="latest-project">Editar</Tooltip>}
      >
        <Button
          className="btn btn-primary btn-sm"
          onClick={() => {
            openEditForm(id);
          }}
        >
          {/* This Button uses a Font Icon, see the installation instructions in the docs. */}
          <i className="flaticon2-pen" />
        </Button>
      </OverlayTrigger>
    );
    buttons.push(
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="latest-project">Eliminar</Tooltip>}
      >
        <Button
          className="btn btn-danger btn-sm ml-2"
          onClick={() => {
            Alert({
              title: "¿Estás seguro?",
              text: "¿Deseas eliminar este Speed Pack?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#D0002E",
              cancelButtonColor: "#aaa",
              confirmButtonText: "Si, elimínalo",
              cancelButtonText: "Cancelar",
            }).then((result) => {
              if (result.value) {
                deleteItem(id);
              }
            });
          }}
        >
          {/* This Button uses a Font Icon, see the installation instructions in the docs. */}
          <i className="flaticon2-delete" />
        </Button>
      </OverlayTrigger>
    );
    return buttons;
  };
  return (
    <AppContainer
      title="Speed Packs"
      hasCreationButton={speedPacksState.hasCreationButton}
      resourceName={speedPacksState.resourceName}
      hasExportationButton={true}
      dataExport={speedPacks}
      headerExport={headersAndSelectors}
      tablePdf={tablePdf}
    >
      <AppTable
        data={speedPacks}
        headersAndSelectors={headersAndSelectors}
        buttonsOfOptions={buttonsOfOptions}
        tablePdf={tablePdf}
      />
    </AppContainer>
  );
};
